import React, { useEffect } from 'react';

import {
  Box,
  Grid,
  Link,
  Theme,
  Typography,
  makeStyles,
} from '@material-ui/core';

import PhoneSrc from '../../../assets/img/phone.svg';
import SendSrc from '../../../assets/img/send.svg';
import WhatsappSrc from '../../../assets/img/whatsapp.svg';
import SuraCard from '../../../components/SuraCard';
import { appConfig } from '../../../config/app';
import { CustomEvents } from '../../../constants/analytics.constant';
import { SURA } from '../../../constants/website.constant';
import useLogEventInAnalytics from '../../../hooks/useLogAnalyticsEvent';

const useStyle = makeStyles((theme: Theme) => ({
  gridMargin: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const Attention = () => {
  const classes = useStyle();
  const { logEvent } = useLogEventInAnalytics();

  const logAnalytics = async () => {
    await logEvent(CustomEvents.OPEN_WHATSAPP, {
      app: appConfig?.NAME,
    });
  };

  const CARDS = [
    {
      colspan: 6,
      image: WhatsappSrc,
      content: (
        <Box display="flex" flexWrap="wrap" flexDirection="column">
          <Typography align="left"> Whatsapp </Typography>
          <Link
            href={`${appConfig?.WHATSAPP_LINK}`}
            rel="noopener"
            target="_blank"
          >
            <Typography align="left" color="secondary">
              <div onClick={() => logAnalytics()}>
                {' '}
                {appConfig?.FORMATED_WHATSAPP}{' '}
              </div>
            </Typography>
          </Link>
        </Box>
      ),
    },
    {
      colspan: 6,
      image: PhoneSrc,
      content: (
        <Box display="flex" flexWrap="wrap" flexDirection="column">
          <Typography align="left"> Teléfono </Typography>
          <Link
            href={`tel:${appConfig?.CONTACT_PHONE}`}
            rel="noopener"
            target="_blank"
          >
            <Typography align="left" color="secondary">
              {appConfig?.FORMATED_CONTACT_PHONE}
            </Typography>
          </Link>
        </Box>
      ),
    },
    {
      colspan: 12,
      image: SendSrc,
      content: (
        <Box display="flex" flexWrap="wrap" flexDirection="column">
          <Typography align="left"> Correo electrónico </Typography>
          <Link
            href={`mailto:${appConfig?.EMAIL}`}
            rel="noopener"
            target="_blank"
          >
            <Typography align="left" color="secondary">
              {appConfig?.EMAIL}
            </Typography>
          </Link>
        </Box>
      ),
    },
  ];

  useEffect(() => {
    const js = document.createElement('script');
    js.type = 'text/javascript';
    js.async = true;
    js.src =
      appConfig?.NAME === SURA
        ? 'https://go.botmaker.com/rest/webchat/p/HYKQSFD1NN/init.js'
        : 'https://go.botmaker.com/rest/webchat/p/QQKPEAW1BH/init.js';
    document.body.appendChild(js);

    return () => {
      const bot = document.getElementsByName('Botmaker');
      if (bot && bot.length) {
        const parent = bot[0].parentElement;

        if (parent) {
          document.body.removeChild(parent);
        }
      }
      document.body.removeChild(js);
    };
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box my={2} mt={5}>
          <Typography variant="h6"> Atención al cliente </Typography>
        </Box>
      </Grid>
      {CARDS.map((card: any, index: number) => (
        <Grid
          item
          xs={12}
          md={card.colspan}
          key={index}
          className={classes.gridMargin}
        >
          <Box height="100%" mr={2}>
            <SuraCard>
              <Box
                width="100%"
                m={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                style={{ overflowWrap: 'anywhere' }}
              >
                <Box
                  width="100%"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>{card.content}</Box>
                  <Box
                    mr={4}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <img src={card.image} alt="siniestro"></img>
                  </Box>
                </Box>
              </Box>
            </SuraCard>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default Attention;
